import "../styles/app.scss"; // Render ECO Stylesheet

// Libraries
import lib from "./js-lib/lib.js";
import cacher from "./js-lib/cacher.js";
import linker from "./js-lib/linker.js";

// Modals
import DefaultModal from "./Modal/DefaultModal.js";
import NavigationModal from "./Modal/NavigationModal";
import SearchModal from "./Modal/SearchModal.js";
// import LanguageModal from "./Modal/LanguageModal";
import cookies from "./Modal/cookies";

// Logic
import ActiveLink from "./Logic/ActiveLink";
import Gform_Upload from "./Logic/gform_upload";
import ProjectFilterModal from "./Modal/ProjectFilterModal";
import gForm from "./Modal/gForm";
import gform_upload from "./Logic/gform_upload";

/* Manage State */
window.state = {
  theme: {
    name: "holland-engineering-2023",
    current: "light",
    opt: ["light", "dark"],
    body: true,
  },
  DefaultModal: {
    name: "DefaultModal",
    current: "open",
    opt: ["closed", "open"],
    body: true,
    bodyclss: "DefaultModal",
  },
  eco: {
    name: "eco",
    current: "disabled",
    opt: ["disabled", "enabled"],
    body: true,
    bodyclss: "EcoMode",
  },
  accountSelection: {
    uid: 0,
  },
  app: {
    pager: {
      view: "view-main",
      cache: false,
      preload: [
        "/",
        "/services/",
        "/the-firm/",
        "/projects/",
        "/clients/",
        "/contact/",
      ],
    },
  },
  account: {
    uid: 0,
    name: "",
    position: "",
    context: "", // Sales, Marketing, Developer, Designer, Default
  },
  feature: {
    eco: false,
  },
  NavigationModal: {
    name: "NavigationModal",
    current: "closed",
    opt: ["closed", "open"],
    body: true,
    bodyclss: "NavigationModal",
    key: ["Escape"],
  },
  SearchModal: {
    name: "SearchModal",
    current: "closed",
    opt: ["closed", "open"],
    body: true,
    bodyclss: "SearchModal",
    key: ["Escape"],
  },
  ProjectFilterModal: {
    name: "ProjectFilterModal",
    current: "closed",
    opt: ["closed", "open"],
    body: true,
    bodyclss: "ProjectFilterModal",
    key: ["Escape"],
  },
  // LanguageModal: {
  //   name: "LanguageModal",
  //   current: "closed",
  //   opt: ["closed", "open"],
  // },
  refresh: false,
  video: [], // Used for Normal MP4 Files
  vimeo: {}, // Used for Vimeo Videos
  wistia: [], // Used for Wistia Videos
  cookies: {
    enabled: null,
    google: false,
    microsoft: false,
  },
};

window.App = {
  load_cache: (data = false) => {
    // Load Eco Cache
    state["account"] = cacher.retrieve("account")
      ? cacher.retrieve("account")
      : state.account;

    DefaultModal.load_cache(state);
    cookies.load_cache(state);

    if (window.location.href.indexOf("?eco") > 0) {
      state.eco.current = "enabled";
      state.theme.current = "dark";
    }

    // NavigationModal.load_cache(state);
  },
  global_scope: (data = false) => {
    // Application Scope (For Single Page Websites)

    // Fetch /wp-json/
    // resting.fetch('/wp-json/', [  ], (App.restResponse), false);
    // resting.fetch('/wp-content/themes/linassico-2023/eco.php', [  ], (App.restResponse), false);

    // Change browser Eco Detection State
    // EcoDetection.render(state);

    if (state.eco.current == "disabled") {
      // pager.init(state.app.pager.view, (App.scope), state.app.pager.cache)
      // measurer.init();
    }

    DefaultModal.global_scope(state);
    NavigationModal.global_scope(state);
    SearchModal.global_scope(state);

    lib.qsa(".navicon").forEach((elem) => {
      elem.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });

    if (state.eco.current === "disabled") {
      App.postScope();
    }

    cookies.render(state);
  },
  scope: (data = false) => {
    // Per Page Scope (For Multi Page Websites)
    // linker.init();

    DefaultModal.scope(state);
    NavigationModal.scope(state);
    SearchModal.scope(state);
    ProjectFilterModal.scope(state);

    // LanguageModal.scope(state);

    cookies.accepted(state);

    if (lib.qs(".gform-index")) {
      if (lib.qs(".gform-index").dataset.id) {
        if (lib.qs("#gform_" + lib.qs(".gform-index").dataset.id)) {
          // Retrieve the Form Element
          lib
            .qs("#gform_" + lib.qs(".gform-index").dataset.id)
            .setAttribute(
              "action",
              lib.siteurl() +
                lib.path() +
                "#" +
                "gravity-form-index-" +
                lib.qs(".gform-index").dataset.id
            );
        }
      }
    }

    // Scroll URL HASH in to view
    if (document.URL.includes("#")) {
      setTimeout(() => {
        if (lib.id(window.location.hash.substring(1))) {
          lib.id(window.location.hash.substring(1)).scrollIntoView();
        }

        if (
          lib.id(
            "gform_confirmation_message_" + lib.qs(".gform-index").dataset.id
          )
        ) {
          lib
            .id(
              "gform_confirmation_message_" + lib.qs(".gform-index").dataset.id
            )
            .scrollIntoView();
        }
      }, 200);
    }

    // const handleForm = (data) => {
    //   console.log(data);
    // };

    // fetch.get(
    //   "wp-admin/admin-ajax.php?action=gf_button_get_form&form_id=1",
    //   handleForm
    // );

    App.render();
    //App.pager();

    if (state.eco.current === "enabled") {
      App.postScope();
    }
  },
  postScope: () => {},
  // pager: (data = false) => {
  //       // Re Render Scope
  //       document.querySelectorAll('.nav-main-link').forEach((elem) => {

  //         elem.addEventListener('click', () => {
  //             toggler.off(lib.qsa('.navigation-modal--toggle'), state.NavigationModal)
  //             console.log('re-state 2');
  //             App.pager();
  //         });
  //     });
  // },
  restResponse: (data) => {},
  render: (data = false) => {
    // All items to be Rendered
    DefaultModal.render(state);
    NavigationModal.render(state);
    Gform_Upload.render(state); // Initialise Form Upload
    // ActiveLink.render(state);
    gForm();
    gform_upload.render();
  },
};

// Wait for the DOM to load
window.onload = function () {
  App.load_cache();
  App.global_scope();
  App.scope();
};
